import 
    {   props } from './properties'

export const setEventTypeList = (state, payload) => {
    
    state.event_types = payload
    
}

export const setFinancialConfig = (state, payload) => {
    
    state.financial_configuration = payload
    
}


// WEBPACK FOOTER //
// ./src/store/modules/budget/mutations.js